import { MultiSelect } from "@mantine/core";
import { useRef } from "react";
import { useField } from ".";

type Props = {
  name: string;
  label?: string;
  placeholder: string;
  disabled?: boolean;
  onChange?: (value: string[] | null) => void;
  options: { value: string; label: string }[];
  defaultvalue?: string[];
  onlyRead?: boolean;
  itemComponent?: any;
  filter?: any;
  maxSelectedValues?: number;
};

export function MultiSelectField({
  name,
  label,
  placeholder,
  onChange: onChangeValue,
  options,
  disabled = false,
  defaultvalue = [],
  onlyRead,
  itemComponent,
  filter = () => {},
  maxSelectedValues,
}: Props) {
  const { value, error, onChange } = useField(name);
  const selectRef = useRef<HTMLInputElement>(null);

  return (
    <MultiSelect
      label={label}
      placeholder={placeholder}
      value={value || []}
      disabled={disabled}
      onChange={(values) => {
        if (!onlyRead) {
          onChange(values);
          onChangeValue && onChangeValue(values);
          selectRef.current?.blur();
        }
      }}
      itemComponent={itemComponent && itemComponent}
      filter={filter && filter}
      error={error}
      required
      clearable
      data={options}
      style={{ flex: 1 }}
      maxSelectedValues={maxSelectedValues}
      withinPortal
      ref={selectRef}
    />
  );
}
